export const AuthRoutes = {
  CHECK_ACTION: 'CHECK_ACTION',
  INVITATION: 'INVITATION',
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  VERIFY: 'VERIFY',
};
